import Vue from 'vue';
import Router from 'vue-router';
import routes from './routers';
import storage from 'libs/storage';
import store from '@/store';
import api from '@/api';
import { Dialog, Toast } from 'vant';
import utils from 'libs/utils';

Vue.use(Router);
const router = new Router({
  routes,
  mode: 'history',
});
const LOGIN_PAGE_NAME = 'login';
const homeName = 'index';
var checkLogin = (to, token, next, from) => {
	// console.log("eee1", to, token)
  if (to.meta.requiresAuth === true) {
		// console.log("eee", to)
    let { t } = to.query;
    if (!utils.isEmpty(t)) {
     utils.loginConfirm(to).then((res)=>{
        if(res){
          store.dispatch('getUserInfo');
          router.replace({name:to.name,params:to.params,query:{}})
        }
      });
    }else if (!token && to.name !== LOGIN_PAGE_NAME) {
      store
        .dispatch('getUserInfo')
        .then((user) => {
          checkLogin(to, user.token, next, from);
        })
        .catch((e) => {
          utils.loginConfirm(to);
        });
      return;
    }else {
      next();
    }
  }else {
		// console.log("88888", to.path)
		// if(to.path == '/mch5/activity/rankdetail'){
		// 	next({
		// 		name: 'rank'
		// 	});
		// }else{
			
		// }
		if (token && to.name === LOGIN_PAGE_NAME) {
		  // 已登录且要跳转的页面是登录页 判断gid 是否一致
		  next({
		    name: homeName, // 跳转到homeName页
		  });
		} else {
		  next();
		}
    
  }
};
router.beforeEach((to, from, next) => {
	// console.log("toooo", to)
  if (to.meta.showloading) {
    Toast.loading();
  }
  //appInfo 原始链接
  let token = utils.getToken();
  if (to.meta.bgcolor) {
    store.commit('setBgColor', to.meta.bgcolor);
  }
  //版本管理
  api.system.getVersion().then((res) => {
    let newver = res.ver;
    storage.get('version').then((res) => {
      //版本发生变化
      if (res !== newver) {
        storage.set('version', newver);
        window.location.reload();
      }
    });
  });
		
	// if(to.path == '/mch5/activity/rankdetail'){
	// 	console.log("9999999")
	// 	next({
	// 		name: 'rank'
	// 	})
	// }else{
	// 	console.log("7777777")
	// 	checkLogin(to, token, next, from);
	// }
	checkLogin(to, token, next, from);
	

  
});
router.afterEach((to,from) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  if (window.__wxjs_is_wkwebview) {
    // IOS
    if (window.entryUrl === '' || window.entryUrl === undefined) {
      window.entryUrl = `${to.fullPath}`;
    }
  } else {
    // 安卓
    window.entryUrl = `${to.fullPath}`;
  }

  if (to.meta.showloading) {
    setTimeout(() => {
      Toast.clear();
    }, 500);
  }
  //处理分享
  utils.wxShareConf();
  if (to.path !== from.path) {
    api.system.shareconfig({path: to.path})
  }
  
});

export default router;
